import React from "react";
import { HomeOutlined, InboxOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Checkbox, Dropdown, Form, Input, Modal, Progress, Select, Table, Upload } from "antd";
import "./status_import_spareparts_master.css";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { MdDriveFolderUpload } from "react-icons/md";
import { IoMdAddCircle } from "react-icons/io";
import { withStatusImportSparepartsMaster } from "./hoc_status_import_spareparts_master";

const StatusImportSparepartsMaster: React.FC<any> = ({
    columns,
    dataSource,
    showUpdateModal,
    isUpdateModalVisible,
    handleUpdateModalCancel,
    handleUpdateProcess,
    uploadProps,
    isUploading,
    uploadProgress,
    selectedUpdateColumns,
    setSelectedUpdateColumns,
    updateColumnOptions,
    fileList,
    showNewModal,
    isNewModalVisible,
    handleNewModalCancel,
    selectedNewColumns,
    setSelectedNewColumns,
    isDownloadingTemplate,
    handleDownloadTemplate,
    newFileList,
    newUploadProps,
    handleNewProcess,
}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const Downloadbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const Importbtn = MdDriveFolderUpload as React.ComponentType<any>;
    const Exportbtn = IoMdAddCircle as React.ComponentType<any>;
    const downloadMenu = {
        items: [
            {
                key: 'new',
                label: 'New Data',
                onClick: () => handleDownloadTemplate('template_spareparts_NewData.xlsx'),
            },
            {
                key: 'update',
                label: 'Update Data',
                onClick: () => handleDownloadTemplate('template_spareparts_data_perbarui.xlsx'),
            },
        ],
    };
    const importMenu = {
        items: [
            {
                key: 'new',
                label: 'Import New Data',
                onClick: showNewModal,
            },
            {
                key: 'update',
                label: 'Import Update Data',
                onClick: showUpdateModal,
            },
        ],
    };
    const nonDisabledColumns = (updateColumnOptions || []).filter((opt: any) => !opt.disabled);
    const isAllNonDisabledChecked = nonDisabledColumns.every((opt: any) => selectedUpdateColumns.includes(opt.value));

    return (
        <div id="ihrq" style={transformStyle}>
            <div className="gjs-grid-row" id="ipez5">
                <div className="gjs-grid-column" id="i4vge">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/spareparts_master",
                                title: (
                                    <>
                                        <span>Data SpareParts</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/browser_data_spareparts",
                                title: (
                                    <>
                                        <span>Browser Data Spareparts</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/status_import_spareparts_master",
                                title: "Status Update Data Sparepart Master",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="i06mc">
                <div className="gjs-grid-column" id="ijd0s">
                    <Button className="gr-button" >
                        <Exportbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                        Export Data
                    </Button>
                    <Dropdown menu={importMenu} trigger={['click']} getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}>
                        <Button className="gr-button">
                            <Importbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                            Import Data
                        </Button>
                    </Dropdown>
                    <Dropdown menu={downloadMenu} trigger={['click']} getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}>
                        <Button className="gr-button" loading={isDownloadingTemplate}>
                            <Downloadbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                            Download Template
                        </Button>
                    </Dropdown>
                </div>
            </div>

            <div className="gjs-grid-row" id="isjn2">
                <div className="gjs-grid-column" id="i3ksd">
                    <Table columns={columns} dataSource={dataSource} rowKey="id" />
                </div>
            </div>
            <Modal
                title="Update Data Item Part via Excel"
                open={isUpdateModalVisible}
                onCancel={handleUpdateModalCancel}
                wrapClassName="modal_remark_proses"
                footer={[
                    <Button key="back" onClick={handleUpdateModalCancel} disabled={isUploading}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleUpdateProcess} disabled={fileList.length === 0 || isUploading || selectedUpdateColumns.length === 0 || !isAllNonDisabledChecked} loading={isUploading}>
                        {isUploading ? 'Memproses...' : 'Proses'}
                    </Button>,
                ]}
                destroyOnClose
            >
                <div style={{ marginBottom: '20px', border: '1px solid #d9d9d9', padding: '12px', borderRadius: '6px' }}>
                    <p style={{ marginBottom: '10px', fontWeight: 500 }}>Pilih kolom yang ingin diperbarui:</p>
                    <Checkbox.Group
                        options={updateColumnOptions}
                        value={selectedUpdateColumns}
                        onChange={(checkedValues) => setSelectedUpdateColumns(checkedValues as string[])}
                        disabled={isUploading}
                    />
                    <p style={{ marginTop: '10px', fontSize: '12px', color: '#8c8c8c' }}>
                        <b>Catatan:</b> Kolom "part no" sebagai kunci untuk menemukan data yang akan diperbarui dan tidak dapat diubah melalui proses ini, Pastikan dengan benar.
                    </p>
                </div>
                <Upload.Dragger {...uploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Silahkan Upload File untuk memperbaharui data</p>
                    <p className="ant-upload-hint">
                        Hanya format .xlsx.
                    </p>
                </Upload.Dragger>
                {isUploading && (
                    <div style={{ marginTop: '20px' }}>
                        <Progress percent={uploadProgress} />
                    </div>
                )}
            </Modal>
            <Modal
                title="Import New Data"
                open={isNewModalVisible}
                onCancel={handleNewModalCancel}
                wrapClassName="modal_remark_proses"
                footer={[
                    <Button key="back" onClick={handleNewModalCancel} disabled={isUploading}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleNewProcess} disabled={newFileList.length === 0 || isUploading} loading={isUploading}>
                        {isUploading ? 'Memproses...' : 'Proses'}
                    </Button>,
                ]}
                destroyOnClose
            >
                <Upload.Dragger {...newUploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Silahkan Upload File untuk mengimport data baru</p>
                    <p className="ant-upload-hint">
                        Hanya format .xlsx.
                    </p>
                </Upload.Dragger>
                {isUploading && (
                    <div style={{ marginTop: '20px' }}>
                        <Progress percent={uploadProgress} />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default withStatusImportSparepartsMaster(StatusImportSparepartsMaster);
